import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CSHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-600">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/hFy2gw5MDd2tt1rRNeVEZd/Clearsilk.jpg)'
    }} data-id="element-601" />
      <div className="absolute inset-0 bg-black/60" data-id="element-602" />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-603">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-604">
          <div className="mb-6" data-id="element-605">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-606">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-607">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-608">
            Be BRAVE
          </span>

          <h1 className="text-[30px] sm:text-5xl lg:text-[56px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-609">
            CLEARSILK LASER FACIALS
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-610">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-611">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body italic" data-id="element-612">
              "It's the perfect lunchtime laser glow that is so popular in
              Korea!" explains Dr. Fiona.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-613">
              At Be CLINICAL we rave about ClearSilk because there is absolutely
              no downtime.{' '}
              <em data-id="element-614">
                "It feels like a pleasant massage and you will have a wonderful
                glow that evening and for a few days and evenings to come!"
              </em>{' '}
              Plus, there are long-term benefits like increased skin density and
              reduction in redness.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-615">
              If you want to improve skin texture, reduce fine lines and
              wrinkles or fade sun spots, the ClearSilk Laser Facial at Be
              CLINICAL is the perfect choice for more youthful looking skin!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-616">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}